import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Small sticky button (bottom-left) to scroll back to top.
 * Appears only after user has scrolled a bit. Placed opposite to the
 * brochure sticky button (bottom-right) to avoid overlap.
 */
export default function BackToTopButton() {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      data-testid="back-to-top-btn"
      aria-label={t('common.backToTop', 'Retour en haut')}
      title={t('common.backToTop', 'Retour en haut')}
      className="fixed bottom-6 left-6 z-40 w-12 h-12 rounded-full bg-[#1A3C34] hover:bg-[#2B4C43] text-white shadow-2xl shadow-black/30 flex items-center justify-center transition-all hover:scale-110 active:scale-95 animate-in fade-in slide-in-from-bottom-4 duration-300"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
